import { useSelector } from "react-redux";
import { ApplicationState } from "@ppb/tbd-store/state/ApplicationState.types";
import { createFindCardbyURNSelector } from "@ppb/tbd-store/state/layout/cards/cards-selectors";
import { createFindCardGroupByURNSelector } from "@ppb/tbd-store/state/layout/cardgroups/cardgroups-selectors";
import { createViewZoneByURNSelector } from "@ppb/tbd-store/state/layout/viewzones/viewzone-selectors";
import { APOLLO_MIGRATED_CARDS } from "@ppb/tbd-store/state/layout/cards/Card.types";

const getFindCardByURN = createFindCardbyURNSelector();
const getFindCardGroupByURN = createFindCardGroupByURNSelector();
const getViewZoneByURN = createViewZoneByURNSelector();

/**
 * Readiness for the container's content slot, which holds a height floor until this is true. An
 * Apollo-migrated typename counts as loaded because it fetches its own data and never lands in the
 * Redux layout slices.
 */
export const useSelectedCardIsLoaded = (urn: string, typename: string): boolean =>
  useSelector(
    (state: ApplicationState) =>
      !!getFindCardByURN(state.layouts.cards, urn) ||
      !!getFindCardGroupByURN(state.layouts.cardgroups, urn) ||
      !!getViewZoneByURN(state.layouts.viewzones, urn) ||
      APOLLO_MIGRATED_CARDS.includes(typename),
  );
